/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
export const NODE_TYPES = {
  input: "transformEngineInputNode",
  protoToXml_full: "protoToXmlTransformNode_full",
  protoToXml_prim: "protoToXmlTransformNode_prim",
  xmlToProto_full: "xmlToProtoTransformNode_full",
  xmlToProto_prim: "xmlToProtoTransformNode_prim",
  output: "outputNode",
  composer: "composerNode",
} as const;

// Define all transform node types as a literal tuple
// We can expand this as we add more transform nodes
export const TRANSFORM_NODE_TYPE_ARRAY = [
  "protoToXmlTransformNode_full",
  "protoToXmlTransformNode_prim",
  "xmlToProtoTransformNode_full",
  "xmlToProtoTransformNode_prim",
] as const;

// Create a union type from the tuple
export type TransformNodeType = (typeof TRANSFORM_NODE_TYPE_ARRAY)[number];

// Convert it to a Set for fast lookup
export const TRANSFORM_NODE_TYPES = new Set<string>(TRANSFORM_NODE_TYPE_ARRAY);

// Type guard to check if a string is a TransformNodeType
export function isTransformNodeType(
  type: string | undefined
): type is TransformNodeType {
  return type !== undefined && TRANSFORM_NODE_TYPES.has(type);
}
